(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Logout",
            {
                url: "/Logout",
                component: "logout",
                PageTitle: "Logout"
            });
        }
    ]);

    app.component("logout",
    {
        controller: logoutController
    });

    logoutController.$inject = ["AuthService"];
    function logoutController(AuthService) {
        AuthService.logout();
    }

})(window.app, window.angular); // jshint ignore:line